export default "__VITE_ASSET__Cyas8oxI__"